import { Button, Modal, Typography } from 'components';
import { CloseIcon, KeyFeaturedIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC, PropsWithChildren } from 'react';
import { cn } from 'utils/cn';
import CardKey from './CardKey';

interface IKeyPopup {
  accessSecret?: string;
  accessKey?: string;
  open: boolean;
  onCancel: () => void;
}

const KeyPopup: FC<PropsWithChildren<IKeyPopup>> = ({
  accessSecret,
  accessKey,
  open,
  onCancel
}) => {
  const t = useTranslations();

  return (
    <Modal
      zDialog={cn('!z-[1999]')}
      zDialogBackdrop="z-[1000]"
      onClose={onCancel}
      open={open}
      className={'max-h-[60vh] w-[665px]'}
    >
      <div className="absolute right-2 top-2 z-[1000]">
        <Button
          size="small"
          variant="icon"
          color="neutral"
          className="!w-8 rounded-full"
          onClick={onCancel}
          startAdornment={<CloseIcon />}
        />
      </div>
      <div
        className={cn(
          'overflow-y-auto px-8 py-6',
          'relative flex w-full flex-col justify-center  gap-2 rounded bg-white shadow-custom'
        )}
      >
        <KeyFeaturedIcon />
        <Typography variant="medium4xl" className=" text-tertiary-100 ">
          {t('integrations.tolq_api_key.key_popup.head')}
        </Typography>
        <Typography variant="light4" className="mt-2 flex">
          {t('integrations.tolq_api_key.key_popup.copy')}
        </Typography>
        <div className="mt-4 flex justify-center gap-6 !rounded-4xl bg-tertiary-900 p-6">
          <CardKey message={accessKey} title={t('integrations.tolq_api_key.key_popup.key_label')} />
          <CardKey
            message={accessSecret}
            title={t('integrations.tolq_api_key.key_popup.secret_label')}
          />
        </div>
        <div className="mt-4 flex justify-end gap-4">
          <Button
            size="medium"
            label={t('buttons.close')}
            onClick={onCancel}
            className="flex items-center"
            variant="text"
          />
        </div>
      </div>
    </Modal>
  );
};

export default KeyPopup;
